module.exports = __webpack_public_path__ + "img/DINPro.9b92e506.svg";